import axios from "axios";
const service = axios.create({
    //本地
    // baseURL: "http://192.168.106.218:9091/VueWebApI/",
    //学校
    baseURL: "https://vlab.njau.edu.cn/njnydx_xnfz/VueWebApI/",
    // baseURL: "http://vlab.njau.edu.cn/njnydx_xnfz/VueWebApI/",
    timeout: 3000,
})
// 请求拦截
service.interceptors.request.use(config => {
    config.headers["Content-type"] = "application/x-www-form-urlencoded"
    // console.log(config.data);
    // 判断是否有token,有就把token带在header里面，
    let token = localStorage.getItem("token");
    if (token) {
        config.headers["X-Token"] = token
    }
    return config
})

// 响应拦截
service.interceptors.response.use(config => {
    // config.data.headers["Content-type"] = "application/json"
    return config.data
})

export default service


// WEBPACK FOOTER //
// ./src/utils/http.js